import Persistable from "../../storage/persistable";

export default class ApplicationConfig extends Persistable {}
